/* ============================================================================
 * Candidate-match shared tokens.
 *
 * Tier thresholds + colour helpers used by the matches list, rows, and the
 * candidate profile modal. (The candidate/score data itself comes from the
 * matching API — see `getRequirementMatches`.)
 * ========================================================================== */

// Tier thresholds (mirrors the design sample).
export const TIERS = {
  best: { label: 'Best Match', min: 78, colorVar: 'var(--ds-success)' },
  near: { label: 'Near Match', min: 55, colorVar: 'var(--ds-warning)' },
  explore: { label: 'Explore', min: 0, colorVar: '#66707F' },
};

export const tierColorVar = (tier) =>
  TIERS[tier]?.colorVar ?? TIERS.explore.colorVar;

// A tinted background derived from a CSS color var — adapts to light/dark.
export const tintFrom = (colorVar, pct = 10) =>
  `color-mix(in srgb, ${colorVar} ${pct}%, transparent)`;
